import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { CircularProgress, Box } from '@mui/material';

const RequireProfile: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hasCheckedOnce, setHasCheckedOnce] = useState(false);

  useEffect(() => {
    let mounted = true;
    let retryTimeout: NodeJS.Timeout;

    const checkProfile = async () => {
      if (!user) {
        if (mounted && hasCheckedOnce) {
          setLoading(false);
          navigate('/login');
        }
        return;
      }

      try {
        const profileRef = doc(db, 'users', user.uid);
        const profileSnap = await getDoc(profileRef);
        
        if (mounted) {
          if (!profileSnap.exists()) {
            navigate('/create-profile');
          }
          setLoading(false);
          setHasCheckedOnce(true);
        }
      } catch (error) {
        console.error('Error checking profile:', error);
        if (mounted) {
          // On error, retry after a short delay
          retryTimeout = setTimeout(checkProfile, 1000);
          setLoading(false);
        }
      }
    };

    checkProfile();

    return () => {
      mounted = false;
      if (retryTimeout) clearTimeout(retryTimeout);
    };
  }, [user, navigate, hasCheckedOnce]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
};

export default RequireProfile; 